import React from "react";

export default function LoadingSkeleton() {
  return (
    <div className="min-h-screen bg-cozy-bg" data-testid="loading-skeleton">
      {/* Hero skeleton */}
      <div className="relative min-h-[88vh] flex items-center bg-cozy-beige/40 overflow-hidden">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 w-full">
          <div className="max-w-2xl space-y-6 animate-pulse">
            <div className="h-6 w-48 bg-cozy-pink/60 rounded-full" />
            <div className="space-y-3">
              <div className="h-12 w-3/4 bg-cozy-gold/30 rounded-2xl" />
              <div className="h-14 w-full bg-cozy-brown/15 rounded-2xl" />
            </div>
            <div className="h-5 w-2/3 bg-cozy-brown/15 rounded-full" />
            <div className="flex gap-3 pt-4">
              <div className="h-12 w-40 bg-cozy-gold/40 rounded-full" />
              <div className="h-12 w-32 bg-cozy-brown/15 rounded-full" />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center py-6">
        <span className="font-script text-2xl text-cozy-gold animate-pulse">loading the magic…</span>
      </div>
    </div>
  );
}
